module.exports = __webpack_public_path__ + "static/media/external_portfolio.ab45819f.svg";